module.exports = __webpack_public_path__ + "static/img/tdbig1.d504207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/tdbig1.jpg
// module id = 0iiW
// module chunks = 0